import { atom } from 'jotai';

import { EventData } from 'src/utils/event-gateway';

export const shakePermissionAtom = atom<ShakePermission>('rejected');

export interface DebugEventLog<T = object> extends EventData<T> {
  date: string;
}
export const debugEventLogsAtom = atom<DebugEventLog[]>([]);

export const debugEventLogFilterAtom = atom({
  eventType: '',
  eventName: '',
});
